module.exports = __webpack_public_path__ + "img/en.748c57b7.svg";